import React, { useState } from 'react'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import InputAdornment from '@material-ui/core/InputAdornment'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import { setInputmultiLanguageValue, valMax } from 'utils'
import InputWrapper from './InputWrapper'
import InputIcon from './InputIcon'
import Autocomplete from "react-google-autocomplete";


const style = makeStyles(theme => ({
  valid: {
    border: `none`,
    borderRadius: 5,
  },
  viewMode: {
    color: `black`,
    border: `none`,
    background: `transparent`,
    padding: theme.spacing(1.5, 0),
    '& > input': {
      background: `transparent`,
    },
  },
  textWarning: {
    color: `#FF5252`,
  },
  textRight: {
    display: `block`,
    textAlign: `right`,
  },
}))

/*
  Manejo de errores
  Hay inputs que muestran mensajes abajos y otros que no
  Por lo que el prop "error" puede ser Boolean o String
*/

export default function TextInputWrapper({
  id,
  label,
  error, //Puede ser boolean o string
  isRequired = false,
  onBlur,
  onChange,
  value,
  name,
  type = `text`,
  inputType = `text`,
  autocompleteData,
  rules: { min = 0, max, required = false } = {},
  size = `small`,
  InputProps = {},
  disabled = false,
  placeholder = ``,
  align = `left`,
  fullWidth = false,
  xs = 12,
  md = 12,
  multiLanguage = false,
  languageKey = ``,
  icon = undefined,
  addonBefore = false,
  isValid = false,
  useNameInsteadId = false,
  color = `primary`,
  viewMode = false,
  showCounter = false,
  maxMessage = `Se ha alcanzado el máximo de caracteres permitido`,
  useOnChangeInsteadOnBlur = false,
  ...rest
}) {
  const classes = style()
  const [localValue, setLocalValue] = useState(multiLanguage ? value[languageKey] : value)
  const isMaxCounter = max && (localValue ? localValue.length : 0) >= max
  const haveErrorWithLang = languageKey ? error && error[languageKey] : error
  const [customType, setCustomType] = useState(type)
  const isPasswordType = type === `password`


  function handleNewValue(nextValue, name) {
    const listenFunction = useOnChangeInsteadOnBlur ? onChange : onBlur
    return listenFunction({
      name: useNameInsteadId ? name : id,
      value: multiLanguage
        ? setInputmultiLanguageValue({
            languageKey,
            value: {
              current: value,
              next: nextValue,
            },
          })
        : nextValue,
      id,
      languageKey,
    })
  }


  
  return (
    <InputWrapper
      label={label}
      isRequired={isRequired || required}
      align={align}
      type={inputType}
      error={error}
      fullWidth={fullWidth}
      xs={xs}
      md={md}
      languageKey={languageKey}
      disabled={disabled}
      {...rest}
    >
       <Autocomplete
        apiKey={'AIzaSyD5y4QtyzKk4QvCBmQHRKutjB45nEl1jvU'}
        className="input-maps"
        onPlaceSelected={(place) => {
          console.log(place["formatted_address"]);
          console.log(place["geometry"]["location"].lat());
          console.log(place["geometry"]["location"].lng());
          //setLocalValue('el lugar');
          handleNewValue(`${place["formatted_address"]}::${place["geometry"]["location"].lat()}::${place["geometry"]["location"].lng()}`, name);
        }}

        options={{
            types: ["geocode", "establishment"],  
            componentRestrictions: { country: "cl" },
          }}
       >
       </Autocomplete>
       <Grid container direction="row" justify="space-between" alignItems="flex-start">
          <Grid item xs={12}>
            
              <Typography variant="caption" className={classes.textLeft}>
                {value}
              </Typography>
            
          </Grid>
         
        </Grid>
      
    </InputWrapper>
  )
}
